import { render, staticRenderFns } from "./AbkNewsTree.vue?vue&type=template&id=77ead75a&scoped=true&"
import script from "./AbkNewsTree.vue?vue&type=script&lang=js&"
export * from "./AbkNewsTree.vue?vue&type=script&lang=js&"
import style0 from "./AbkNewsTree.vue?vue&type=style&index=0&id=77ead75a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ead75a",
  null
  
)

export default component.exports